<template>
  <van-nav-bar
          :title="title"
          :right-text="rightText"
          left-arrow
          @click-left="onClickLeft"
          @click-right="toSearch"
          :list="isList"
  />
</template>

<script>
  import Vue from 'vue';
  import {NavBar} from 'vant';
  Vue.use(NavBar);
  export default {
    name: "navBar",
    data(){
      return{

      }
    },
    props:{
      title:{
        type:[Number,String],
        default:''
      },
      rightText:{
        type:[String],
        default: ''
      },
      isList:{
        type:Boolean,
        default:false
      }

    },
    methods:{
      //返回
      onClickLeft() {
        if(this.isList){
          this.$router.push('/');
        }else{
          this.$router.go(-1);
        }

      },
      toSearch() {
        this.$router.push('/search');
      }
    }
  }
</script>

<style>
  .van-nav-bar__title {
    font-size: 18px;
  }

  .van-nav-bar .van-icon {
    color: #333;
    font-size: 20px;
  }

  .van-nav-bar__text {
    color: #999;
  }
  .van-tabs__wrap--scrollable .van-tabs__nav {
    padding-bottom: 10px;
  }

  .van-tab {
    font-size: 16px;
    color: #999;
  }

  .van-tab--active {
    color: #333;
  }

  [class*=van-hairline]::after {
    border: none;
  }
</style>
